import api from '../axiosConfig';

const API_URL = '/api/reports';

export const getDepartmentWisePendingReport = async (params = {}) => {
  const response = await api.get(`${API_URL}/department-wise-pending`, { params });
  return response.data;
};

export const getDepartmentWiseProductionReport = async (params = {}) => {
  const response = await api.get(`${API_URL}/department-wise-production`, { params });
  return response.data;
};